export default {
  activeMenuItemGridId: state => state.sideNav.activeItem.gridId,
  currentPageTitle: (state) => {
    const breadcrumbs = state.breadcrumbs.data;
    return breadcrumbs.length && breadcrumbs[breadcrumbs.length - 1].text;
  },
  firstName: state => (state.userInfo.fullName ? state.userInfo.fullName.split(' ')[0] || '' : ''),
  lastName: state => (state.userInfo.fullName ? state.userInfo.fullName.split(' ')[1] || '' : ''),
  getRouteName: state => (id) => {
    let childMenuItems = [];
    const parentItem = state.sideNav.data.find((item) => {
      childMenuItems = childMenuItems.concat(item.childMenuItems);
      return item.id == id;
    });
    if (!parentItem) {
      var childList = flattenChildMenuItems(childMenuItems);
      const childItem = childList.find(item => item.id == id);
      if (!childItem) return '';
      return childItem.name;
    }
    return parentItem.name;
  },
  finalRoutes: state => getChildIfExists(state.sideNav.data),
  isAutoSearch: state => !!(state.sideNav.activeItem.properties || {}).autoSearch,
  isAdminUser: state => isAdminUser(state.userInfo),
};

const getChildIfExists = (nodes) => {
  const finalNodes = [];
  (nodes || []).forEach((node) => {
    if (node.route) {
      finalNodes.push(node);
    }
    finalNodes.push(...getChildIfExists(node.childMenuItems));
  });
  return finalNodes;
};
const flattenChildMenuItems = (data) => {
  if (!data) return [];
  return data.reduce((r, { childMenuItems, ...rest }) => {
    r.push(rest);
    if (childMenuItems) r.push(...flattenChildMenuItems(childMenuItems));
    return r;
  }, []);
};
const isAdminUser = userInfo => !!(userInfo || {}).isAdmin;
